import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, CardMedia, Avatar, Typography, Snackbar, Slide, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export default function NoticiaAlerta() {
  const API_URL = 'https://api.workers.grupotel.com/';

  const [noticia, setNoticia] = useState(null);
  const [open, setOpen] = useState(false);

  const marcarNoticiaComoVista = async () => {

    if (!noticia?.id) {
      console.log("No se encontró el ID de la noticia.");
      return;
    }

    const fd = new FormData();
    fd.append("f", "noticia.setNoticiaVisto");
    fd.append("id_noticia", noticia.id);
    fd.append("token", localStorage.getItem('token'));

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        body: fd
      });

      const result = await response.json();
      if (result.error?.id !== 0) {
        console.log("Error al marcar como vista:", result.error.msg);
      } else {
        setOpen(false);
      }
    } catch (error) {
      console.log("Error al marcar como vista:", error);
    }

  };

  useEffect(() => {
    const obtenerNoticia = async () => {

      if (!localStorage.getItem('token')) {
        return;
      }

      const fd = new FormData();
      fd.append("f", "noticia.getNoticias");
      fd.append("token", localStorage.getItem('token'));

      try {
        const response = await fetch(`${API_URL}`, {
          method: 'POST',
          body: fd,
        });
        const result = await response.json();
        // console.log(result)
        if (result?.error?.id === 0) {
          setNoticia(result.data[0]);
          setOpen(true);
          // console.log(result.data[0])
        }
      } catch (error) {
        console.log("Error cargando noticia:", error);
      }
    };

    obtenerNoticia();
  }, []);

  if (!noticia) return null;

  return (
    <Snackbar
      open={open}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    // autoHideDuration={10000} // Ocultarse automaticamente
    >
      <Card sx={{ maxWidth: 400 }}>
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: '#00a2dc' }}>!</Avatar>}
          action={
            <IconButton onClick={marcarNoticiaComoVista}>
              <CloseIcon />
            </IconButton>
          }
          title={
            <Typography className="bold" variant="subtitle1">
              {noticia.asunto}
            </Typography>
          }
          subheader={
            noticia.fecha
          }
        />
        {noticia.foto && (
          <CardMedia
            component="img"
            // height="180"
            className='centrar imagenDimensiones'
            image={'https://api.workers.grupotel.com/imagenes/noticias/' + noticia.foto}
            alt="Noticia"
            onClick={() => { window.open('https://api.workers.grupotel.com/imagenes/noticias/' + noticia.foto); }}
          />
        )}
        <CardContent>
          <Typography variant="body2" color="text.secondary" className="textoNoticia" sx={{ 'white-space': 'break-spaces' }}
          // dangerouslySetInnerHTML={{ __html: noticia.texto }}
          >
            {noticia.texto}
          </Typography>
          {noticia.pdf && (
            <Typography variant="body2" color="text.secondary" className="textoNoticia" sx={{ 'white-space': 'break-spaces', 'justify-self': 'right' }} >
              <a href={'https://api.workers.grupotel.com/documentos/noticias/' + noticia.pdf} target="_blank">Leer más</a>
            </Typography>
          )}
        </CardContent>
      </Card>
    </Snackbar>
  );
}
